import styled from 'styled-components';

import { Icon } from '../Icon/Icon';

const themes = {
  1: {
    colorText: 'var(--color-blue-3)',
    colorIcon: 'var(--color-blue-3)',
    colorHover: 'var(--color-red-2)',
  },
  2: {
    colorText: 'var(--color-grey-11_60)',
    colorIcon: 'var(--color-grey-11_60)',
    colorHover: 'var(--color-black)',
  },
  3: {
    colorText: 'var(--color-white)',
    colorIcon: 'var(--color-white)',
    colorHover: 'var(--color-white_68)',
  },
};

const sizes = {
  xs: {
    fontRegular: 'var(--font-regular-11)',
    fontLarge: 'var(--font-large-11)',
  },
  s: {
    fontRegular: 'var(--font-regular-13)',
    fontLarge: 'var(--font-large-13)',
  },
  m: {
    fontRegular: 'var(--font-regular-15)',
    fontLarge: 'var(--font-large-15)',
  },
  l: {
    fontRegular: 'var(--font-regular-17)',
    fontLarge: 'var(--font-large-17)',
  },
};

export const Container = styled.span`
  --color-text: ${(p) => (themes[p.theme] || themes['1']).colorText};
  --color-icon: ${(p) => (themes[p.theme] || themes['1']).colorIcon};
  --color-hover: ${(p) => (themes[p.theme] || themes['1']).colorHover};
  --font-regular: ${(p) => (sizes[p.size] || sizes['m']).fontRegular};
  --font-large: ${(p) => (sizes[p.size] || sizes['m']).fontLarge};

  display: inline;
  opacity: ${(p) => p.disabled && '50%'};

  cursor: ${(p) => (p.disabled ? 'not-allowed' : 'pointer')};

  &:hover {
    a,
    button {
      color: ${(p) => !p.disabled && 'var(--color-hover)'};
    }

    span > svg {
      --color: ${(p) => !p.disabled && 'var(--color-hover)'};
    }
  }
`;

export const StyledLink = styled.a`
  display: inline;
  color: var(--color-text);
  text-decoration: none;
  word-break: break-word;
  white-space: normal;
  pointer-events: ${(p) => (p.isDisabled ? 'none' : 'auto')};
  font: ${(p) => `var(--font-${p.fontWeight})`};
`;

export const StyledButton = styled.button`
  all: unset;
  display: inline;
  color: var(--color-text);
  word-break: break-word;
  white-space: normal;
  pointer-events: ${(p) => (p.isDisabled ? 'none' : 'auto')};

  font: ${(p) => `var(--font-${p.fontWeight})`};
`;

export const ContentWrapper = styled.span`
  display: inline;
`;

export const Text = styled.span`
  display: inline;
  vertical-align: middle;
`;

export const StyledIcon = styled(Icon)`
  --color: var(--color-icon);

  display: inline-block;
  vertical-align: middle;
  margin-right: ${(p) => p.iconLeft && '4px'};
  margin-left: ${(p) => p.iconRight && '4px'};
`;
